import { useReadQuery } from '@apollo/client';
import { FreeStreamBanner } from '@/routes/_app.p.streams_.$id/stream-banner/free-stream-banner.tsx';
import { PaidStreamBanner } from '@/routes/_app.p.streams_.$id/stream-banner/paid-stream-banner.tsx';
import { StreamBannerEmptyState } from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner-empty-state.tsx';
import { useMe } from '@/routes/_app/use-me.ts';
import {
  AuthenticatedStreamLoaderData,
  useStreamLoaderData,
} from '../loader.ts';
import {
  useFollowStream,
  useUnfollowStream,
} from '../use-toggle-follow-stream.ts';

export const StreamBanner = () => {
  const { streamQueryRef } =
    useStreamLoaderData() as AuthenticatedStreamLoaderData;
  const { data } = useReadQuery(streamQueryRef);
  const stream = data?.stream;

  const me = useMe();
  const isMe = me.username === stream?.author.username;

  const [followStream, followResult] = useFollowStream(stream?.id as string);
  const [unfollowStream] = useUnfollowStream(stream?.id as string);
  const toggleFollow = !stream?.following ? followStream : unfollowStream;

  if (!stream) return <StreamBannerEmptyState />;

  return (
    <>
      {stream.paidData?.length ? (
        <PaidStreamBanner
          stream={stream}
          isMe={isMe}
          toggleFollow={toggleFollow}
          followLoading={followResult.loading}
        />
      ) : (
        <FreeStreamBanner
          stream={stream}
          isMe={isMe}
          toggleFollow={toggleFollow}
          followLoading={followResult.loading}
        />
      )}
    </>
  );
};
